module.exports = __webpack_public_path__ + "static/line-9832f2a2289d604b9733f161315e0949.jpg";